import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

/** What a delete confirmation asks: `message1 <b>resourceName</b>? message2`. */
export interface ConfirmDialogData {
  title: string;
  message1: string;
  resourceName: string;
  message2: string;
}

export interface ConfirmActionData {
  title: string;
  /** Material icon name shown next to the title. */
  icon: string;
  message: string;
  /** Set in bold after `message`, closing the question. */
  resourceName?: string;
  messageAfter?: string;
  confirmLabel: string;
  /** An irreversible action: error colours and a warning under the title. */
  destructive?: boolean;
}

@Component({
  selector: 'app-confirm-dialog',
  imports: [MatButton, MatDialogActions, MatDialogContent, MatIcon],
  templateUrl: './confirm-dialog.html',
})
export class ConfirmDialog {
  readonly data = inject<ConfirmActionData>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<ConfirmDialog>);
}
